// used to return process env attributes - since accessing process.env.VUE_APP_... variables via a "vue" file shows a lint error
// probably would be fine, but the red squiggle unnerved me
export class EnvService {
    public getAttribute(attribute : string){
        return process.env[attribute] ?? 'whoops'
    }
}